import { Badge, Button, Divider, FileInput, Flex, Grid, Modal } from '@mantine/core'
import './SalesInstallmentsConfirmModal.css'
import { IconAlertHexagonFilled, IconPhoto } from '@tabler/icons-react'
import { renderFile } from '../../utils/renderFile';
import { useState } from 'react';


export default function SalesInstallmentsConfirmModal({ onClose, installment, opened, onConfirmFunction, isLoading }) {

    const [currentData, setCurrentData] = useState(installment)
    const [receiptImage, setCurrentReceiptImage] = useState(null)

    return <Modal
        opened={opened}
        onClose={onClose}
        title="¡Atención!"
        classNames={{ title: "SalesInstallmentConfirmModal-modalTitle" }}
    >
        <div className="SalesInstallmentConfirmModal-father-div">
            <div className="SalesInstallmentConfirmModal-warning-container">
                <IconAlertHexagonFilled className="SalesInstallmentConfirmModal-alertIcon" />
                <p className="SalesInstallmentConfirmModal-modalText">
                    Estás por marcar como PAGADA la cuota, <br />asegurate de estar seguro del
                    siguiente cambio.
                </p>
            </div>

            <Grid
                mt={12}
            >

                <Divider
                    label='Información de la cuota'
                    w='100%'
                />

                <Grid.Col span={12} pb={0}>
                    <h4 className='SalesInstallmentsConfirmModal-item-headline'>Nombre: <span>{currentData?.payer_name} {currentData?.payer_lastname}</span></h4>
                </Grid.Col>
                <Grid.Col span={12} pb={0}>
                    <h4 className='SalesInstallmentsConfirmModal-item-headline'>Email: <span>{currentData?.payer_email}</span></h4>
                </Grid.Col>
                <Grid.Col span={12} pb={0}>
                    <h4 className='SalesInstallmentsConfirmModal-item-headline'>Telefono: <span>{currentData?.payer_phone}</span></h4>
                </Grid.Col>
                <Grid.Col span={12} pb={0}>
                    <h4 className='SalesInstallmentsConfirmModal-item-headline'>Cuotas: <span>{`${currentData?.installment_cycle}/${currentData?.installments_total_cycles}`}</span>
                    </h4>
                </Grid.Col>

                <Grid.Col span={12} pb={0}>
                    <h4 className='SalesInstallmentsConfirmModal-item-headline'>Plataforma de pago: <span>{currentData?.platform}</span>
                    </h4>
                </Grid.Col>
                <Grid.Col span={12} pb={0}>
                    <h4 className='SalesInstallmentsConfirmModal-item-headline'>Moneda: <span>{currentData?.installment_currency}</span>
                    </h4>
                </Grid.Col>
                <Grid.Col span={12} pb={0} mb={12}>
                    <h3 className='SalesInstallmentsConfirmModal-item-headline'>Importe a abonar: <strong>${currentData?.installments_agreedAmount}</strong>
                    </h3>
                </Grid.Col>
                <Divider
                    w='100%'
                />

                <Grid.Col span={receiptImage ? 8 : 12}>
                    <FileInput
                        label="Cargar  comprobante de pago"
                        description="Si no corresponde, no cargar ningun comprobante."
                        w={"100%"}
                        placeholder="Cargar imagen"
                        leftSection={<IconPhoto size={30} />}
                        // disabled={loading}
                        onChange={(file) => {
                            renderFile(file).then((_fileBase64) => {
                                setCurrentData(prev => ({ ...prev, cycle_receipt: _fileBase64 }))
                                setCurrentReceiptImage(_fileBase64)
                            });
                        }}
                        accept={["image/*", "application/pdf"]}
                    />
                </Grid.Col>
                {receiptImage && <Grid.Col span={4}>
                    <img src={receiptImage}
                        className='SalesInstallmentsConfirmModal-receipt-image-preview'
                    />
                </Grid.Col>}
                <Grid.Col span={6}>
                    <Button
                        w='100%'
                        onClick={onClose}

                        type='button'
                        variant='outline'
                    >
                        Volver
                    </Button>
                </Grid.Col>
                <Grid.Col span={6}>
                    <Button
                        w='100%'
                        type='button'
                        onClick={() =>
                            onConfirmFunction(currentData)
                        }
                        disabled={isLoading}
                    >
                        Marcar como pagada
                    </Button>
                </Grid.Col>
            </Grid>
        </div>
    </Modal>
}